<template>
    <div class="aBox">
        <div class="art-left">
            <div class="silder-left">
                <div class="silder-tit">{{pName}}</div>
                <div class="line"><span></span></div>
                <ul>
                    <li :class="{'active':isActive==index}" v-for="(item,index) in newsTab" :key="index">
                      <a href="javascript:;" @click="jumpToChild(item,index)">{{item.name}}</a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 提示框 -->
    <tip :tip="tip" v-show="tipShow"></tip>
    </div>
</template>

<script>
import { getArtCates } from "../api/api";

export default {
  components: {},
  data() {
    return {
      newsTab: [], //存放新闻列表数据
      pName: "", //父栏目名称
      isActive: 0, //控制激活样式
      tip: {}, //提示语
      tipShow: false //提示框默认状态
    };
  },
  created() {
    this._getArtCates(); // 获取父，子栏目信息
  },
  mounted() {},
  methods: {
    // 获取父，子栏目信息
    _getArtCates() {
      let module = {
        sch_id: 1,
        topic_id: 6
      };
      getArtCates(module)
        .then(res => {
          if (res.status && res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].id == this.$route.params.cid) {
                this.pName = res.data[i].name;
                this.newsTab = res.data[i].children;
              }
            }
          } else {
            this.tipCtr("暂无数据");
          }
        })
        .catch(err => {
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //提示框函数
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1200);
    },

    //跳转子栏目
    jumpToChild(item, index) {
      this.$router.push({ path: item.id });
      this.isActive = index;
    },
    //监听头部路由
    myroute() {
      this._getArtCates();
    }
  },
  watch: {
    $route: "myroute"
  }
};
</script>

<style scoped>
/*左边菜单*/
.art-left {
  width: 280px;
  float: left;
  overflow: hidden;
}

/*menu*/
.silder-left {
  width: 100%;
  padding: 20px;
  background: #ffffff;
  overflow: hidden;
  border: 1px solid #ddd;
}

.silder-tit {
  color: #333;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
}

.line {
  background: #ddd;
  width: 100%;
  height: 1px;
  margin: 15px 0;
}

.line span {
  float: left;
  width: 40%;
  height: 1px;
  background: #428bca;
}

.silder-left ul li a {
  color: #666;
  font-size: 14px;
  display: inline-block;
  height: 40px;
  text-indent: 20px;
  line-height: 40px;
  width: 100%;
}

a {
  text-decoration: none;
}

li {
  list-style: none;
}

.silder-left ul li.active {
  background: #428bca;
}

.silder-left ul li.active a {
  color: #ffffff;
}

.silder-left ul li:hover {
  background: #f0f0f2;
}

.silder-left ul li:hover a {
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/asideComp.vue